module.exports = __webpack_public_path__ + "img/empty-orgs.4c63ea13.svg";